import { Question } from "types";

export interface Coordinates {
    x: number;
    y: number;
}

export enum Orientation {
    HORIZONTAL = 0,
    VERTICAL = 1
}

export interface ShipLocation {
    startCoordinate: Coordinates;
    orientation: Orientation
    size: number;
}

export interface Team {
    name: string;
    color?: string;
    shipLocations: ShipLocation[];
}

export interface CardData {
    locationCode: string; // grid card label
    coordinates: Coordinates;
    question?: Question;
    answered?: boolean;
    shipTeam?: string; // ship owner team name 
    ship?: ShipLocation;
    shipPartIndex?: number;
}
export interface GridData {
    cardRows: CardData[];
}

export enum BattleshipGameTypes {
    REMOTE_COMPETITION,
    LIVE_MULTI_TEAM,
    SINGLE_PLAYER,
}

export interface BattleshipQuizSetup {
    gameType: BattleshipGameTypes;
    columns: number;
    rows: number;
    teams: Team[];
    cooldownSec?: number;
}

export interface BattleshipUserSessionAdditionalInfo {
    answeredCards?: {
        locationCode: string;
        correct?: boolean;
    }[];
    shipStatus?: { sunkShips: number; teamName: string }[];
}
